import axios, {
  AxiosInstance,
  AxiosResponse,
  AxiosError,
  InternalAxiosRequestConfig,
} from "axios";
import config from "@/constants/Config";
import Cookies from "js-cookie";
import qs from "qs";
import { buildLoginUrl } from "@/utils/loginUrlUtils";

const options = {
  baseURL: config.API_URL,
};

const instance: AxiosInstance = axios.create(options);

// Add a request interceptor
instance.interceptors.request.use(
  (requestConfig: InternalAxiosRequestConfig) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    requestConfig.paramsSerializer = (params: any) => {
      return qs.stringify(params, { arrayFormat: "repeat" });
    };
    if (requestConfig.url && requestConfig.url.indexOf("rest") !== -1) {
      const csrfName = sessionStorage.getItem("csrf_name");
      const csrf = csrfName ? Cookies.get(csrfName) : undefined;
      if (csrf !== undefined && csrf !== null) {
        requestConfig.headers["X-CSRF-TOKEN"] = csrf;
      }
    }

    if (config.MODE === "development") {
      requestConfig.withCredentials = true;
    }
    return requestConfig;
  },
  (requestError: AxiosError) => {
    return Promise.reject(requestError);
  }
);

// Add a response interceptor
instance.interceptors.response.use(
  (response: AxiosResponse) => {
    if (response && response.headers) {
      const headers = response.headers;

      const cacheControl = String(headers["cache-control"] || "");
      if (
        cacheControl &&
        (cacheControl.includes("no-store") || cacheControl.includes("no-cache"))
      ) {
        const sntVersion = headers["snt-version"]
          ? headers["snt-version"]
          : null;
        if (
          sntVersion &&
          sessionStorage.getItem("NEWEST-SNT-VERSION") !== sntVersion
        ) {
          sessionStorage.setItem("NEWEST-SNT-VERSION", sntVersion);
        }
      } else {
        // cache response should be ignored
      }
    }
    return response;
  },
  (error: AxiosError) => {
    if (axios.isCancel(error)) {
      console.log("cancel");
    } else if (error.response && 401 === error.response.status) {
      const pathname = window.location.pathname;
      if (
        pathname !== "/login" &&
        pathname !== "/login/" &&
        pathname !== "/oauth2/authorize"
      ) {
        const orgId = window.loginInfo?.organisation?.id;
        if (pathname === "/") {
          window.location.href = buildLoginUrl(orgId);
        } else {
          window.location.href = buildLoginUrl(
            orgId,
            pathname + window.location.search
          );
        }
      }
    }
    return Promise.reject(error);
  }
);

export const apiClient = instance;
